export const data = {
  firstName: "Aboubaker",
  lastName: "Id Hamide",
  phone: "+ 2126 59 85 47 79",
  linkedIn: "https://www.linkedin.com/in/aboubaker-idhamide",
  github: "https://www.github.com/AboubakerIdHamide",
  location: "Marrakesh, SidZouine",
  about: `As a full-stack developer, I am constantly drawn to the thrill of learning and improving my |SKILLS| in the field. I have a strong foundation in front-end and back-end technologies , and I am always eager to explore new technologies and push myself to be the best developer I can be. I started learning full-stack development in 2021 and have been hooked ever since. If you share a similar passion for tech and are open to connecting with other professionals in the industry, please feel free to reach out to me on |LINKEDIN|. I am always looking for new opportunities to learn and collaborate with others in the field.`,
  image: "assets/my-image.jpg",
  job: "Full-Stack Developer",
  skills: [
    {
      id: 1,
      name: "PHP",
      exp: "1 year",
      projects: 1,
      progress: 30,
      icon: "https://img.icons8.com/officel/144/null/php-logo.png",
      bg: "#dcd5f277",
      definition:
        "PHP is a server-side scripting language used for web development. It is a popular language for creating dynamic and interactive websites and web applications.",
    },
    {
      id: 2,
      name: "JavaScript",
      exp: "10 months",
      projects: 30,
      progress: 35,
      icon: "https://img.icons8.com/color/144/null/javascript--v1.png",
      bg: "#ffd60077",
      definition:
        "JavaScript is a high-level, interpreted programming language that is widely used for client-side web development. It is often used to add interactivity and dynamic effects to web pages.",
    },
    {
      id: 3,
      name: "HTML 5",
      exp: "1 year",
      projects: 30,
      progress: 40,
      icon: "https://img.icons8.com/external-tal-revivo-color-tal-revivo/144/null/external-html-5-is-a-software-solution-stack-that-defines-the-properties-and-behaviors-of-web-page-logo-color-tal-revivo.png",
      bg: "#e44d2677",
      definition:
        "HTML 5 is the fifth version of the Hypertext Markup Language (HTML) standard. It is used for creating and structuring web content, and provides a foundation for building dynamic and interactive websites.",
    },
    {
      id: 4,
      name: "CSS 3",
      exp: "1 year",
      projects: 30,
      progress: 50,
      icon: "https://img.icons8.com/external-tal-revivo-color-tal-revivo/144/null/external-cascading-style-sheets-language-used-for-describing-the-presentation-of-a-document-logo-color-tal-revivo.png",
      bg: "#2062af77",
      definition:
        "CSS 3 is the latest version of the Cascading Style Sheets (CSS) language. It is used for describing the presentation of web content and allows web developers to control the layout and appearance of web pages.",
    },
    // {
    //   id: 5,
    //   name: "TypeScript",
    //   exp: "1 week",
    //   projects: 0,
    //   progress: 5,
    //   icon: "https://img.icons8.com/fluency/144/null/typescript--v2.png",
    //   bg: "#1791e877",
    //   definition: "TypeScript is a superset of JavaScript that adds optional type annotations and other features to improve the development experience. It can help catch bugs and improve maintainability of code, making it a popular choice for large-scale web development projects."
    // },
    {
      id: 6,
      name: "ReactJs",
      exp: "3 months",
      projects: 1,
      progress: 15,
      icon: "https://img.icons8.com/color/144/null/react-native.png",
      bg: "#80deea77",
      definition:
        "ReactJS is a JavaScript library for building user interfaces. It allows developers to create reusable UI components and manage the state of their applications efficiently.",
    },
    {
      id: 7,
      name: "Sass",
      exp: "1 week",
      projects: 1,
      progress: 20,
      icon: "https://img.icons8.com/color/144/null/sass.png",
      bg: "#f0629277",
      definition:
        "Sass (Syntactically Awesome Stylesheets) is a CSS preprocessor that adds various features to standard CSS, such as variables, mixins, and functions, to make styling web pages more efficient and manageable.",
    },
    // {
    //   id: 8,
    //   name: "GIT",
    //   exp: "3 months",
    //   projects: 1,
    //   progress: 25,
    //   icon: "https://img.icons8.com/color/144/null/git.png",
    //   bg: "#f4511e77",
    //   definition:
    //     "GIT is a distributed version control system for tracking changes in source code during software development. It allows multiple developers to work on the same codebase and keep track of changes made by each individual.",
    // },
    // {
    //   id: 9,
    //   name: "GITHUB",
    //   exp: "3 months",
    //   projects: 1,
    //   progress: 35,
    //   icon: "https://img.icons8.com/glyph-neue/144/null/github.png",
    //   bg: "#06060677",
    //   definition:
    //     "GitHub is a web-based platform for version control and collaboration that uses Git. It allows developers to host and review code, manage projects, and build software alongside a large community of developers.",
    // },
    // {
    //   id: 10,
    //   name: "Python",
    //   exp: "2 months",
    //   projects: 1,
    //   progress: 25,
    //   icon: "https://img.icons8.com/color/144/null/python--v1.png",
    //   bg: "#ffc10777",
    //   definition:
    //     "Python is a high-level programming language known for its clear and concise syntax, making it an ideal language for beginners and experienced programmers alike. It can be used for a wide range of applications, such as web development, data science, and artificial intelligence.",
    // },
    {
      id: 12,
      name: "MySQL",
      exp: "1 year",
      projects: 1,
      progress: 40,
      icon: "https://img.icons8.com/fluency/144/null/my-sql.png",
      bg: "#ea7c0177",
      definition:
        "MySQL is a popular open-source relational database management system (RDBMS) used for organizing and retrieving data stored in databases. It is widely used for web applications and data-driven websites.",
    },
    {
      id: 13,
      name: "MongoDb",
      exp: "1 year",
      projects: 0,
      progress: 15,
      icon: "https://img.icons8.com/color/144/null/mongodb.png",
      bg: "#4caf5077",
      definition:
        "MongoDB is a cross-platform document-oriented NoSQL database. It stores data in flexible, JSON-like documents, making it easier to work with and scale compared to traditional relational databases.",
    },
    {
      id: 14,
      name: "WordPress",
      exp: "1 week",
      projects: 0,
      progress: 5,
      icon: "https://img.icons8.com/fluency/144/null/wordpress.png",
      bg: "#0f518d77",
      definition:
        "WordPress is a content management system (CMS) that powers millions of websites on the internet. It is open-source software that allows users to create and manage websites with ease, without needing to write any code.",
    },
    // {
    //   id: 15,
    //   name: "NextJs",
    //   exp: "3 days",
    //   projects: 1,
    //   progress: 15,
    //   icon: "https://img.icons8.com/color/144/null/nextjs.png",
    //   bg: "#21212177",
    //   definition:'Next.js is a JavaScript framework for building server-side rendered and statically generated web applications. It provides a simple way for developers to create fast, dynamic, and SEO-friendly websites.'
    // },
    // {
    //   id: 16,
    //   name: "Jquery",
    //   exp: "1 month",
    //   projects: 1,
    //   progress: 25,
    //   icon: "https://img.icons8.com/ios-filled/144/000000/jquery.png",
    //   bg: "#78cff5",
    //   definition:
    //     "jQuery is a fast, small, and feature-rich JavaScript library that makes HTML document manipulation, event handling, and animation much simpler with an easy-to-use API.",
    // },
    // {
    //   id: 17,
    //   name: "Bootstrap",
    //   exp: "1 month",
    //   projects: 1,
    //   progress: 25,
    //   icon: "https://img.icons8.com/color/144/null/bootstrap.png",
    //   bg: "#673ab777",
    //   definition:
    //     "Bootstrap is a popular open-source front-end framework that makes it easier to create responsive, mobile-first web pages. It provides a set of CSS classes and JavaScript plugins that can be used to build modern, stylish websites with ease.",
    // },
    {
      id: 18,
      name: "Laravel",
      exp: "1 month",
      projects: 0,
      progress: 5,
      icon: "https://img.icons8.com/fluency/144/null/laravel.png",
      bg: "#f9322c77",
      definition:
        "Laravel is a free, open-source PHP framework used for web application development. It follows the model-view-controller (MVC) architectural pattern and offers a range of tools and features for building modern, robust, and scalable web applications.",
    },
    // {
    //   id: 19,
    //   name: "MUI",
    //   exp: "2 weeks",
    //   projects: 0,
    //   progress: 8,
    //   icon: "https://img.icons8.com/color/144/000000/material-ui.png",
    //   bg: "#0081CB77",
    //   definition: "Material-UI is a popular React UI library that provides a set of ready-to-use components for building beautiful and responsive web applications. It follows Google's Material Design guidelines and offers extensive customization options."
    // },
    // {
    //   id: 20,
    //   name: "Vue.js",
    //   exp: "2 days",
    //   projects: 1,
    //   progress: 9,
    //   icon: "https://img.icons8.com/color/144/000000/vue-js.png",
    //   bg: "#4FC08D77",
    //   definition:
    //     "Vue.js is a progressive JavaScript framework used for building user interfaces and single-page applications. It offers a simple and intuitive API, two-way data binding, and a reactive system that makes it easy to build scalable and maintainable applications.",
    // },
    {
      id: 21,
      name: "Node.js",
      exp: "2 hours",
      projects: 1,
      progress: 10,
      icon: "https://img.icons8.com/color/144/000000/nodejs.png",
      bg: "#3C873A77",
      definition:
        "Node.js is a popular open-source server-side runtime environment used for building scalable and high-performance web applications. It uses an event-driven, non-blocking I/O model that makes it lightweight and efficient, and provides a vast library of modules and tools for building applications.",
    },
    {
      id: 22,
      name: "Express.js",
      exp: "2 hours",
      projects: 1,
      progress: 9,
      icon: "https://img.icons8.com/color/144/000000/express.png",
      bg: "#F0DB4F77",
      definition:
        "Express.js is a minimalist web framework for Node.js that provides a set of features for building web applications and APIs. It offers a simple API for routing, middleware, and templating, and is highly customizable and extensible.",
    },
    {
      id: 23,
      name: "Electron.js",
      exp: "2 Months",
      projects: 1,
      progress: 8,
      icon: "https://img.icons8.com/?size=100&id=q9tRM28hhsGL&format=png&color=000000",
      bg: "#9feaf977",
      definition:
        "Electron.js is an open-source framework for building cross-platform desktop applications using web technologies such as HTML, CSS, and JavaScript. It allows developers to create native-like applications for Windows, macOS, and Linux using a single codebase.",
    },
    {
      id: 24,
      name: "Java",
      exp: "1 month",
      projects: 1,
      progress: 7,
      icon: "https://img.icons8.com/color/144/000000/java-coffee-cup-logo.png",
      bg: "#f8982077",
      definition:
        "Java is a high-level, class-based, object-oriented programming language that is widely used for building web applications, mobile applications, and enterprise software. It is known for its portability, performance, and security features.",
    },
    {
      id: 25,
      name: "SpringBoot",
      exp: "1 month",
      projects: 1,
      progress: 6,
      icon: "https://img.icons8.com/color/144/000000/spring-logo.png",
      bg: "#6db33f77",
      definition:
        "Spring Boot is an open-source Java-based framework used for building stand-alone, production-grade Spring applications. It provides a range of features for building web applications, microservices, and enterprise applications with ease.",
    },
    {
      id: 26,
      name: "Tailwind",
      exp: "1 month",
      projects: 1,
      progress: 5,
      icon: "https://img.icons8.com/?size=100&id=4PiNHtUJVbLs&format=png&color=000000",
      bg: "#06b6d477",
      definition:
        "Tailwind CSS is a utility-first CSS framework that provides a set of pre-built classes for styling web content. It allows developers to quickly build custom designs without writing custom CSS, making it a popular choice for modern web development projects.",
    },
  ],
  projects: [
    {
      id: 1,
      img: "assets/projects/project_01.png",
      title: "Leon",
      link: "https://aboubakeridhamide.github.io/HTML-CSS-TEMPLATE/",
      techs: ["HTML 5", "CSS 3", "GIT", "GITHUB"],
      desc: "This project is a HTML and CSS template that I built by following along with a tutorial on YouTube. Through this project, I learned the basics of HTML and CSS and how to use them to create a simple, responsive website. I also learned how to use Google Fonts and some basic tips and tricks with pseudo elements in CSS3. Overall, this project helped me to understand the foundations of web development and gave me the confidence to continue learning and building more complex projects",
    },
    {
      id: 2,
      img: "assets/projects/project_02.png",
      title: "Kasper",
      link: "https://aboubakeridhamide.github.io/HTML-CSS-TEMPLATE.2/",
      techs: ["HTML 5", "CSS 3", "GIT", "GITHUB", "JavaScript"],
      desc: "This project is a continuation of the HTML and CSS template that I built by following along with a tutorial on YouTube. Through this project, I was able to further develop my skills in web design and learned how to use Font Awesome inside a CSS file. I also learned some basic commands in Git, which helped me to better understand version control. Overall, this project allowed me to build upon the knowledge and skills that I had acquired in my previous project and helped me to become more confident and proficient as a web developer.",
    },
    {
      id: 3,
      img: "assets/projects/project_03.png",
      title: "Elzero",
      link: "https://aboubakeridhamide.github.io/HTML-CSS-TEMPLATE.3/",
      techs: ["HTML 5", "CSS 3", "GIT", "GITHUB", "JavaScript"],
      desc: "This project is a continuation of my journey to learn web development through YouTube tutorials. In this project, I focused on learning the structure of landing pages and some advanced CSS effects. Through this process, I was able to further develop my skills as a web developer and began to understand how I can learn and grow on my own. Overall, this project represents an important step in my journey as a developer and I am excited to continue learning and building new projects.",
    },
    {
      id: 4,
      img: "assets/projects/project_04.png",
      title: "Gonex",
      link: "https://aboubakeridhamide.github.io/HTML-CSS-JS-TEMPLATE.4/",
      techs: ["HTML 5", "CSS 3", "GIT", "GITHUB", "JavaScript"],
      desc: "This project is a HTML, CSS, and JavaScript template that I built using a design PSD file as a reference. I did not use any tutorials to complete this project and was able to develop the code entirely on my own. I really enjoyed working on this project because it allowed me to use advanced JavaScript techniques, such as the IntersectionObserver API, to create a more dynamic and interactive user experience. Through this project, I was able to continue growing as a web developer and build upon the skills and knowledge that I had acquired in my previous projects. Overall, this project represents an important milestone in my journey as a developer and I am proud to have completed it without relying on any external resources.",
    },
    {
      id: 6,
      img: "assets/projects/project_06.png",
      title: "ShareMe",
      link: "https://idhamide-shareme.netlify.app/",
      techs: ["ReactJs", "HTML 5", "JavaScript"],
      desc: "This project is a picture sharing platform that I developed by following along with a tutorial on YouTube. Through this project, I learned the basics of React.js and gained a better understanding of the structure of files in a React application. I also learned how to implement Google authentication in a React application and became more open-minded about using npm libraries and learned that it is often more efficient to utilize existing tools rather than trying to reinvent the wheel. I also learned how to use react-router-dom to handle routing in a React application, and discovered technologies like Sanity and Tailwind that I had not been previously familiar with. Overall, this project helped me to learn and grow as a developer and I am excited to continue learning and building new projects with React.",
    },
    {
      id: 7,
      img: "assets/projects/project_07.png",
      title: "ID-SHOP",
      link: "https://ecommerce-react-app-aboubakeridhamide.vercel.app/",
      techs: ["NextJs", "HTML 5", "JavaScript", "GITHUB", "GIT"],
      desc: "This project is an e-commerce application that I developed using Next.js, a flexible React framework. Prior to working on this project, I had no prior experience with Next.js, so this project represented an opportunity for me to learn about this technology and see how it compares to other React frameworks. In the process of completing this project, I learned about the structure of a Next.js application and how to use React context to manage state. I also learned how to integrate Stripe for payment processing. Overall, this project was a valuable learning experience and helped me to gain a better understanding of Next.js and its capabilities as a React framework. Although I know that I still have much more to learn, I feel that this project was a good starting point and I am excited to continue learning and building with Next.js.",
    },
    {
      id: 10,
      img: "assets/projects/project_10.png",
      title: "LaraGigs",
      link: "https://github.com/AboubakerIdHamide/laragigs",
      techs: ["Laravel", "HTML 5", "MySQL"],
      desc: "LaraGigs is a web application built using the Laravel PHP framework. During the development of this project, I learned the basics of Laravel through tutorials on YouTube and gained hands-on experience with the framework. The result is a fully functional CRUD (Create, Read, Update, Delete) application, which showcases my knowledge and understanding of these technologies. The project allowed me to further develop my skills and become more familiar with the Laravel ecosystem. Overall, LaraGigs was a valuable learning experience and has helped me to become a more well-rounded web developer thanks to the knowledge I gained from YouTube tutorials.",
    },
    {
      id: 14,
      img: "assets/projects/project_14.png",
      title: "iLander",
      link: "https://github.com/AboubakerIdHamide/iLander-Elementor",
      techs: ["WordPress", "Elementor"],
      desc: "The iLander WordPress Landing Page is a website template built using Elementor, a popular drag-and-drop page builder plugin for WordPress. This template was created as part of a YouTube crash course where I learned how to use Elementor by building the iLander landing page. It provided me with hands-on experience in designing and customizing websites using the Elementor interface. Throughout the course, I gained valuable knowledge about creating responsive layouts, adding animations, and integrating various widgets and plugins. I'm excited to apply these skills to future web development projects and continue expanding my proficiency with Elementor and WordPress.",
    },
    {
      id: 12,
      img: "assets/projects/project_12.png",
      title: "Cancan",
      link: "https://github.com/AboubakerIdHamide/cancan",
      techs: ["Laravel", "MongoDB", "Vue.js"],
      desc: "Cancan is a powerful and sleek Kanban board web application that I developed using Laravel, MongoDB, and Vue.js. This project provided me with a great opportunity to learn how to build APIs using Laravel and to work with MongoDB as my database for the first time. I also gained valuable experience in front-end development using Vue.js. Cancan is a user-friendly and intuitive tool that enables teams to easily manage their workflow, track progress, and collaborate effectively. I am proud of the results I achieved with Cancan and look forward to developing more innovative and efficient solutions in the future.",
    },
    {
      id: 13,
      img: "assets/projects/project_13.png",
      title: "Paper",
      link: "https://github.com/AboubakerIdHamide/Paper",
      techs: ["React Native", "React Navigation"],
      desc: "The Paper is a mobile application built using React Native, and React Navigation. It was my first React Native project, and it allowed me to learn how to use styles and navigate between components in the context of mobile development. The app was designed to replace the paper materials I had to bring to my driving school, providing a more convenient and efficient learning experience. Through this project, I gained valuable experience with new technologies and learned how to develop for mobile platforms. I'm excited to continue learning and growing as a junior developer, and I look forward to building more innovative and useful mobile applications in the future.",
    },
    {
      id: 8,
      img: "assets/projects/project_08.png",
      title: "My Portfolio",
      link: "https://aboubaker.netlify.app/",
      techs: ["ReactJs", "HTML 5", "JavaScript", "Sass"],
      desc: "This project is my personal portfolio, which I developed using React.js and Sass. Through this project, I became more familiar with React and gained experience working with Sass to create a more stylish and professional-looking website. The goal of this portfolio is to provide an overview of my career as a developer and showcase my skills and accomplishments. I hope that this portfolio will help me to connect with potential employers and opportunities to continue learning and growing as a full-stack developer. If you are interested in learning more about me or want to work with me, please do not hesitate to contact me.",
    },
    {
      id: 11,
      img: "assets/projects/project_11.png",
      title: "B-projects",
      link: "https://b-projects.netlify.app",
      techs: ["JavaScript", "HTML 5", "CSS 3"],
      desc: "B-projects is a collection of my early web development projects. I utilized JavaScript, HTML 5, and CSS 3 to create a series of projects that showcase my skills and my progress as a developer. One notable feature of these projects is my first attempt at creating horizontal scrolling, which taught me the importance of user experience in web development. Additionally, I gained valuable experience in using APIs, learning how to retrieve and manipulate data from external sources. I am proud of my achievements with B-projects and am eager to continue growing as a developer.",
    },
    {
      id: 9,
      img: "assets/projects/project_09.png",
      title: "MAHA",
      link: "https://github.com/AboubakerIdHamide/MAHA",
      techs: [
        "PHP",
        "HTML 5",
        "CSS 3",
        "GITHUB",
        "GIT",
        "MySQL",
        "Jquery",
        "Bootstrap",
      ],
      desc: "This project is an e-learning platform that I developed in a team with Hicham, Mustafa, and Ahmed. It was a great opportunity to work with a team and learn from my colleagues. Through this project, I learned how to use PHPMailer to send emails and became more familiar with using SDKs. I also gained a deeper understanding of the importance of version control systems and became more familiar with tools like merging and resolving conflicts. Working with a team on this project was a valuable experience and helped me to understand the importance of collaboration in software development. It was a challenging but rewarding experience, and it helped me to gain confidence in my skills as a developer.",
    },
    {
      id: 5,
      img: "assets/projects/project_05.png",
      title: "El Wifaq",
      link: "https://www.elwifaqngo.ma/",
      techs: ["HTML 5", "CSS 3", "PHP", "JavaScript", "MySQL"],
      desc: "This project is a CRUD application that I developed for a client using PHP and MySQL. The goal of the project was to build a website that allows users to register for school transportation. In the process of completing this project, I developed my skills as a back-end developer and learned how to generate PDF files using PHP libraries, upload images, use FTP, and deploy a PHP application. I also learned how to use Ajax to create a more dynamic and interactive user experience. Although the final product may not have been of the highest quality, the client was satisfied with the result. Overall, this project represents an important learning experience in my career and helped me to gain valuable experience working on a real-world project for a client.",
    },
    {
      id: 15,
      img: "assets/projects/project_15.png",
      title: "InfinityScript.CV",
      link: "https://github.com/AboubakerIdHamide/InfinityScript.CV",
      techs: ["Laravel", "ReactJS"],
      desc: "InfinityScript.CV is a dynamic and feature-rich resume builder developed using Laravel API and ReactJS. This project provides a user-friendly interface for users to effortlessly create and download professional resumes. It features multilingual support, allowing seamless switching between English and Arabic for a personalized user experience. Users can easily create and customize detailed resumes with sections for education, experience, skills, and more. The application also allows users to download polished and professionally styled resumes in PDF format.",
    },
    {
      id: 16,
      img: "assets/projects/project_16.png",
      title: "PharmaFusion",
      link: "",
      techs: ["ElectronJS", "ReactJS", "NodeJS", "SQLite", "ExpressJS"],
      desc: "PharmaFusion is a comprehensive pharmacy management application I developed using Electron, React, and Express.js. This project was crucial in enhancing my skills as a full-stack developer. Through its development, I learned how to implement role-based authorization, make Express server responses multilingual, and gained experience with Electron from development to packaging. The application allows for effective management of pharmacy inventory, sales, clients, and includes detailed product tracking sold piece by piece. This project represents a significant step in my career, providing me with valuable experience in handling complex requirements and delivering a functional product.",
    },
  ].reverse(),
};

export const urlRoot = "https://aboubaker.netlify.app/";
// export const urlRoot = "http://localhost:3000/";

export const bgEffects = {
  fpsLimit: 120,
  interactivity: {
    events: {
      onClick: {
        enable: true,
        mode: "push",
      },
      onHover: {
        enable: true,
        mode: "repulse",
      },
      resize: true,
    },
    modes: {
      push: {
        quantity: 4,
      },
      repulse: {
        distance: 200,
        duration: 0.4,
      },
    },
  },
  particles: {
    color: {
      value: "#DA0037",
    },
    links: {
      color: "#DA0037",
      distance: 150,
      enable: true,
      opacity: 0.5,
      width: 1,
    },
    collisions: {
      enable: true,
    },
    move: {
      directions: "none",
      enable: true,
      outModes: {
        default: "bounce",
      },
      random: false,
      speed: 2,
      straight: false,
    },
    number: {
      density: {
        enable: true,
        area: 800,
      },
      value: 80,
    },
    opacity: {
      value: 0.5,
    },
    shape: {
      type: "cube",
    },
    size: {
      value: { min: 1, max: 5 },
    },
  },
  detectRetina: true,
};
